import styled from 'styled-components'

import { Menu } from 'antd'

const { Item } = Menu

const MenuItem = styled(Item)``

export default MenuItem
